module.exports = __webpack_public_path__ + "img/workorder.f8b0660d.svg";